"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLTFLoaderInstance = void 0;
var HttpClient_1 = require("../../modules/http-client/HttpClient");
var GltfLoaderTexture_1 = require("./GLTFHelpers/GltfLoaderTexture");
var MaterialPropertiesStandard_1 = require("../materials/MaterialPropertiesStandard");
var SceneHierarchy_1 = require("./GLTFHelpers/SceneHierarchy");
var GltfLoaderBuffer_1 = require("./GLTFHelpers/GltfLoaderBuffer");
var THREE = require("../../externals/three.js");
var GLBLoaderSingleton = require("./GLBLoader.js");
var PbrMaterialConverter_1 = require("../materials/PbrMaterialConverter");
/**
 ShapeDiver 3D Viewer Application

 GLtfLoader.js

 Content:
   Loader used to load gltf files and convert them into THREE.Object3D objects.

  Copyright (c) 2019 ShapeDiver GmbH

  @module GLTFLoader
 */
// require axios for AJAX requests
var SUPPORTED_EXTENSIONS = ["KHR_materials_pbrSpecularGlossiness"];
var THREE_BLENDING = THREE;
var THREE_SIDE = THREE;
var GLTFLoader = /** @class */ (function () {
    function GLTFLoader() {
    }
    // #region Public Methods (4)
    GLTFLoader.prototype.error = function () { };
    /**
     * Loads a binary glb file and creates a THREE.Object3D from the content.
     * @param  {String} url        URL of a binary glb file
     * @param  {THREE.Matrix4[]} transforms Array of transformation matrices to be applied to the resulting glb
     * @param  {Number} tol        Tolerance used for discretisation of NURBS geometry. Defaults to 0.001.
     * @return {Promise<module:OutputVersion~GeometryData[]>} Definition of geometry representing the content of the glb.
     */
    GLTFLoader.prototype.loadGeometry = function (url, transforms, tol, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var httpOptions, response, headers, mimeType, isBinary, gltfObj, dataView, glTFmagic, i_1, version, sceneByteLength, glTFString, i, error_1, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        httpOptions = {
                            timeout: 120000,
                            responseType: HttpClient_1.HttpClientInstance.responseType.ArrayBuffer,
                            headers: {}
                        };
                        if (requestHeaders.authorization) {
                            httpOptions.headers['Authorization'] = requestHeaders.authorization;
                        }
                        return [4 /*yield*/, HttpClient_1.HttpClientInstance.getAsync(url, httpOptions)];
                    case 1:
                        response = _a.sent();
                        headers = response.headers;
                        mimeType = headers.hasOwnProperty("content-type") ? headers["content-type"] : "";
                        isBinary = mimeType.includes("binary/octet-stream") || mimeType.includes("model/gltf-binary") || mimeType.includes("application/octet-stream") || mimeType.includes("model/gltf.binary");
                        if (!isBinary && !mimeType.includes("model/gltf+json") && !mimeType.includes("application/json")) {
                            throw new Error("Unexpected Content-Type " + mimeType + " for glTF 2.0");
                        }
                        gltfObj = isBinary ? response.data : JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response.data)));
                        if (isBinary) {
                            dataView = new DataView(response.data);
                            glTFmagic = "";
                            for (i_1 = 0; i_1 < 4; ++i_1) {
                                glTFmagic = glTFmagic + String.fromCharCode(dataView.getUint8(i_1));
                            }
                            if (glTFmagic != "glTF") {
                                throw new Error("ShapeDiverGLtfLoader got invalid data: glTF magic wrong.");
                            }
                            version = dataView.getUint32(4, true);
                            if (version != 2) {
                                return [2 /*return*/, GLBLoaderSingleton.loadGeometry(url, transforms, tol, headers)];
                            }
                            sceneByteLength = dataView.getUint32(12, true);
                            glTFString = "";
                            i = 0;
                            for (; i < sceneByteLength; ++i) {
                                glTFString = glTFString + String.fromCharCode(dataView.getUint8(20 + i));
                            }
                            gltfObj = JSON.parse(glTFString);
                            // 28 for offset of gltf magic + bytes which describe chunk length and type of total 8 ( 2 * 4)
                            gltfObj.glTFBinaryDataByteOffset = 28 + sceneByteLength;
                            gltfObj.dataView = new DataView(response.data, gltfObj.glTFBinaryDataByteOffset);
                        }
                        else {
                            if (gltfObj.asset.version != "2.0") {
                                return [2 /*return*/, GLBLoaderSingleton.loadGeometry(url, transforms, tol, headers)];
                            }
                        }
                        // append base url to gltf object
                        gltfObj.baseUrl = this.removeLastDirectoryPartOf(url);
                        if (!gltfObj.baseUrl && window && window.location && window.location.href) {
                            gltfObj.baseUrl = this.removeLastDirectoryPartOf(window.location.href);
                        }
                        return [2 /*return*/, this.processGltfAsync(gltfObj, transforms)];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        msg = "";
                        if (error_1.response) {
                            msg = "Loading gltf failed with status " + error_1.response.status + ".";
                        }
                        else if (error_1.request) {
                            msg = "No response to gltf download AJAX request.";
                        }
                        return [2 /*return*/, Promise.reject(new Error(msg))];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GLTFLoader.prototype.log = function () { };
    GLTFLoader.prototype.warn = function (msg) {
        console.warn(msg);
    };
    // #endregion Public Methods (4)
    // #region Private Methods (5)
    GLTFLoader.prototype.createDefaultMaterialForGLtfDef = function () {
        var material = new MaterialPropertiesStandard_1.MaterialPropertiesStandard();
        material.side = THREE.DoubleSide;
        material.metalness = 1;
        material.roughness = 1;
        return material;
    };
    GLTFLoader.prototype.createGeometries = function (gltf, node, accessors) {
        var keyAttribute = {
            POSITION: "position",
            JOINTS_0: "joint",
            WEIGHTS_0: "weight",
            NORMAL: "normal",
            TEXCOORD_0: "uv",
            COLOR_0: "color",
            TANGENT: "tangent"
        };
        var normalize = {
            POSITION: false,
            NORMAL: false,
            TEXCOORD_0: false,
            COLOR_0: true,
            TANGENT: false,
            JOINTS_0: false,
            WEIGHTS_0: false
        };
        var geometries = [];
        node.mesh.primitives.forEach(function (primitive) {
            var geometry = new THREE.BufferGeometry();
            var box = new THREE.Box3();
            geometry.boundingSphere = box.getBoundingSphere();
            geometry.boundingSphere.realCenter = geometry.boundingSphere.center.clone();
            // geometry.translate(-geometry.boundingSphere.center.x, -geometry.boundingSphere.center.y, -geometry.boundingSphere.center.z);
            var attributes = primitive.attributes || {};
            var indices = null;
            if (primitive.hasOwnProperty("indices")) {
                indices = primitive.indices;
            }
            var interleavedBuffer = null;
            var _loop_1 = function (key) {
                var accessor = accessors.find(function (x) { return x.id == attributes[key]; });
                if (accessor) {
                    var bufferView = accessor.bufferView;
                    if (bufferView.isInterleaved) {
                        if (interleavedBuffer == null) {
                            interleavedBuffer = new THREE.InterleavedBuffer(bufferView.interleavedBuffer, bufferView.numOfTypeArrayElementsPerVertex);
                        }
                        geometry.addAttribute(keyAttribute[key], new THREE.InterleavedBufferAttribute(interleavedBuffer, accessor.elementComponentsSize, accessor.offsetForInterleaved));
                    }
                    else {
                        geometry.addAttribute(keyAttribute[key], new THREE.BufferAttribute(accessor.bufferArray, accessor.elementComponentsSize, normalize[key]));
                    }
                }
            };
            for (var key in attributes) {
                _loop_1(key);
            }
            if (indices != null) {
                var accessor = accessors.find(function (x) { return x.id == indices; });
                geometry.setIndex(accessor.array);
            }
            geometries.push(geometry);
        });
        // geometry.translate(-geometry.boundingSphere.center.x, -geometry.boundingSphere.center.y, -geometry.boundingSphere.center.z);
        return geometries;
    };
    GLTFLoader.prototype.createMaterials = function (node, textures) {
        var _this = this;
        var res = [];
        var alphaMode = {
            OPAQUE: THREE_BLENDING.NormalBlending,
            BLEND: THREE_BLENDING.AdditiveBlending,
            MASK: THREE_BLENDING.MultiplyBlending
        };
        node.materials.forEach(function (gltfMaterial) {
            var _a, _b;
            var _c, _d, _e;
            var material = _this.createDefaultMaterialForGLtfDef();
            var pbr = (_c = gltfMaterial.pbrMetallicRoughness) !== null && _c !== void 0 ? _c : {};
            if (pbr.doubleSided || gltfMaterial.doubleSided) {
                material.side = THREE.DoubleSide;
            }
            else if (pbr.doubleSided === false || gltfMaterial.doubleSided === false) {
                material.side = THREE.FrontSide;
            }
            if (pbr.hasOwnProperty("baseColorFactor")) {
                var color = pbr.baseColorFactor;
                material.color = new ((_a = THREE.Color).bind.apply(_a, __spread([void 0], color)))();
            }
            if (pbr.hasOwnProperty("baseColorTexture")) {
                material.map = textures[pbr.baseColorTexture.index].texture;
            }
            if (pbr.hasOwnProperty("metallicFactor")) {
                material.metalness = pbr.metallicFactor;
            }
            if (pbr.hasOwnProperty("roughnessFactor")) {
                material.roughness = pbr.roughnessFactor;
            }
            if (pbr.hasOwnProperty("metallicRoughnessTexture")) {
                material.metalnessMap = textures[pbr.metallicRoughnessTexture.index].texture;
                material.roughnessMap = textures[pbr.metallicRoughnessTexture.index].texture;
            }
            if (gltfMaterial.hasOwnProperty("normalTexture")) {
                material.normalMap = textures[gltfMaterial.normalTexture.index].texture;
            }
            if (gltfMaterial.hasOwnProperty("alphaMode")) {
                material.blending = alphaMode[gltfMaterial.alphaMode];
                if (material.blending == THREE_BLENDING.MultiplyBlending) {
                    material.alphaTest = 0.5;
                }
            }
            else {
                material.blending = THREE.NoBlending;
            }
            if (gltfMaterial.hasOwnProperty("alphaCutoff")) {
                material.alphaTest = gltfMaterial.alphaCutoff;
            }
            if (gltfMaterial.hasOwnProperty("extensions")) {
                if (gltfMaterial.extensions.hasOwnProperty("KHR_materials_pbrSpecularGlossiness")) {
                    var converter = new PbrMaterialConverter_1.PbrMaterialConverter();
                    var pbr_1 = gltfMaterial.extensions.KHR_materials_pbrSpecularGlossiness;
                    // load diffuse 
                    var metallicRoughness = converter.convertToMetallicRoughness({
                        diffuseFactor: (_d = pbr_1.diffuseFactor) !== null && _d !== void 0 ? _d : [1.0, 1.0, 1.0, 1.0],
                        specularFactor: (_e = pbr_1.specularFactor) !== null && _e !== void 0 ? _e : [1.0, 1.0, 1.0],
                        glosinessFactor: pbr_1.glossinessFactor || 1.0
                    });
                    material.color = new ((_b = THREE.Color).bind.apply(_b, __spread([void 0], metallicRoughness.baseColor)))();
                    material.roughness = metallicRoughness.roughness;
                    material.metalness = metallicRoughness.metallic;
                    if (pbr_1.hasOwnProperty("baseColorTexture")) {
                        material.map = textures[pbr_1.diffuseTexture.index].texture;
                    }
                }
            }
            res.push(material);
        });
        return res;
    };
    GLTFLoader.prototype.processGltfAsync = function (gltf, transforms) {
        return __awaiter(this, void 0, void 0, function () {
            var scene, buffers, textures, accessors, i, i, outputGeometry_1, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (gltf.extensionsUsed) {
                            gltf.extensionsUsed.forEach(function (ext) {
                                if (!SUPPORTED_EXTENSIONS.some(function (x) { return x === ext; })) {
                                    _this.warn("Extension " + ext + " not supported.");
                                }
                            });
                        }
                        scene = new SceneHierarchy_1.SceneHierarchy(gltf);
                        buffers = [];
                        textures = [];
                        accessors = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        // buffers
                        for (i in gltf.buffers) {
                            buffers.push(new GltfLoaderBuffer_1.GltfLoaderBuffer(Number.parseInt(i), gltf));
                        }
                        return [4 /*yield*/, Promise.all(buffers.map(function (e) { return e.onLoad; }))];
                    case 2:
                        _a.sent();
                        buffers.forEach(function (buffer) {
                            buffer.bufferViews.forEach(function (bufferView) {
                                bufferView.accessors.forEach(function (accessor) { return accessors.push(accessor); });
                            });
                        });
                        // textures
                        for (i in gltf.textures) {
                            textures.push(new GltfLoaderTexture_1.GltfLoaderTexture(Number.parseInt(i), gltf, buffers));
                        }
                        return [4 /*yield*/, Promise.all(textures.map(function (e) { return e.onLoad; }))];
                    case 3:
                        _a.sent();
                        outputGeometry_1 = [];
                        scene.allNodes.forEach(function (node) {
                            if (!transforms || !Array.isArray(transforms) || transforms.length === 0) {
                                transforms = [new THREE.Matrix4()];
                            }
                            var _loop_2 = function (transformIndex) {
                                if (node.mesh) {
                                    var geometries = _this.createGeometries(gltf, node, accessors);
                                    var index_1 = 0;
                                    geometries.forEach(function (geometry) {
                                        // if names are not defined or empty add them
                                        if (node && (!node.name || node.name === ""))
                                            node.name = "node_" + index_1;
                                        if (node && node.mesh && (!node.mesh.name || node.mesh.name === ""))
                                            node.mesh.name = "mesh_" + index_1;
                                        if (node.mesh && node.materials.length === 0) {
                                            var pathString = "transformation_" + transformIndex + "." + node.name + "." + node.mesh.name + "." + index_1++;
                                            var geometryDefinition = {
                                                path: pathString,
                                                geometry: geometry,
                                                initialMatrix: node.matrix.clone().premultiply(transforms[transformIndex]),
                                                type: "mesh"
                                            };
                                            outputGeometry_1.push(geometryDefinition);
                                        }
                                        else if (node.mesh) {
                                            var materials = _this.createMaterials(node, textures);
                                            materials.forEach(function (material) {
                                                var pathString = "transformation_" + transformIndex + "." + node.name + "." + node.mesh.name;
                                                var geometryDefinition = {
                                                    path: pathString,
                                                    geometry: geometry,
                                                    material: material,
                                                    initialMatrix: node.matrix.clone().premultiply(transforms[transformIndex]),
                                                    type: "mesh"
                                                };
                                                outputGeometry_1.push(geometryDefinition);
                                            });
                                        }
                                    });
                                }
                            };
                            for (var transformIndex = 0; transformIndex < transforms.length; transformIndex++) {
                                _loop_2(transformIndex);
                            }
                        });
                        return [2 /*return*/, Promise.resolve(outputGeometry_1)];
                    case 4:
                        error_2 = _a.sent();
                        console.error(error_2);
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    GLTFLoader.prototype.removeLastDirectoryPartOf = function (the_url) {
        var the_arr = the_url.split("/");
        the_arr.pop();
        return the_arr.join("/");
    };
    return GLTFLoader;
}());
exports.GLTFLoaderInstance = new GLTFLoader();
